// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1OQzw","overflowing":"ReadFullNote_overflowing__dr44F"};